export const getPreferredScheme = () => window?.matchMedia?.('(prefers-color-scheme:light)')?.matches ? 'light' : 'dark';

export const filterPostsByType = ( posts, type ) => type ? posts.filter( post => post.type?.toLowerCase() === type ) : posts;

// https://stackoverflow.com/a/74076627/2527692
export const clamp = (num, min, max) => num > max ? max : num < min ? min : num;

// https://stackoverflow.com/a/43183804/2527692
export const randomInt = (min, max) => Math.floor(min + Math.random()*(max - min + 1));